import {Component, OnInit, OnDestroy,Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import { EducationModulesService } from '../education-modules/education-modules.service';
import { CategoryListModel } from './category-list.model';
import { CategorySectionListModel } from './category-section-list.model';
@Component({
  selector: 'categorylist',
  templateUrl: './category-list.component.html'
})
export class CategoriesListComponent implements OnInit, OnDestroy {
  paramSub: Subscription;
  categories:  CategoryListModel[];
  categoriessections: CategorySectionListModel[];
  @Input() view:string;
  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private educationModulesService: EducationModulesService) {
  }
  ngOnInit() {
  //   this.paramSub = this._route.params.subscribe(params => {
  //     this.view = params['view'];
  //     console.log('value for view' + this.view);
  //     this.educationModulesService.getCategoryList().subscribe(
  //         categories => {
  //           this.categories = categories;
  //           console.log("inside this.CategoriesListComponent.getCategoryList()");
  //           console.log(categories[1].vName);

  //         },
  //         err => {
  //           console.log(err);
  //         });

  // });
  this.paramSub = this._route.params.subscribe(params => {
    this.view = params['view'];
    console.log('value for view' + this.view);
    this.educationModulesService.getCategorySectionList().subscribe(
      categoriessection => {
          this.categoriessections = categoriessection;
          console.log("inside this.CategoriesListComponent.getCategoryList()");
          console.log(categoriessection[2].vSectionName);

        },
        err => {
          console.log(err);
        });

});
}
 ngOnDestroy() {
   // this.paramSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/category-list/category-list.component.ts